import styled from "styled-components";
import { Row } from "../../../../components/flex/styled";

export const PayrollSettingsWrapper = styled("div")(() => {
  return {
    padding: 0,
    backgroundColor: "var(--background-color)",
    borderRadius: "1rem",
    "& form": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "1rem",
      overflow: "hidden",
      backgroundColor: "transparent",
      padding: 0,
      border: "none",
    },
    "& button": {
      marginTop: "var(--sectionMargin)",
      marginLeft: "auto",
    },
    "& h2": {
      marginBlock: 0,
      fontSize: "24px",
      color: "var(--color-text)",
    },
    "& h3": {
      fontSize: "20px",
      fontWeight: 700,
      color: "var(--color-text)",
    },
    "& p": {
      fontSize: "18px",
      color: "var(--color-text)",
    },
    "& label": {
      color: "var(--color-text)",
      flex: 0.4,
    },
    "& input": {
      width: "auto",
      fontWeight: "400",
      backgroundColor: "var(--background-color)",
    },
    "& select": {
      width: "auto",
      backgroundColor: "var(--background-color)",
    },
    "& .field-row": {
      width: "100%",
      overflow: "hidden",
      alignItems: "flex-start",
      backgroundColor: "var(--color-primary-hover)",
      border: "1px solid #e5e7eb",
      borderRadius: "0.85rem",
      padding: "1rem",
      gap: "1rem",
    },
    "@media screen and (min-width: 768px)": {
      padding: 0,
      "& .field-row": {
        alignItems: "center",
        flexDirection: "row",
      },
    },
    "& .payroll-setup-success-modal": {
      width: "min(520px, calc(100% - 32px)) !important",
    },
    "& .payroll-setup-success-modal > div": {
      width: "100%",
      margin: 0,
      backgroundColor: "var(--color-background) !important",
      padding: "var(--cardPadding) !important",
      borderRadius: "24px !important",
      boxShadow: "0 24px 60px rgba(41, 49, 112, 0.2) !important",
      border: "1px solid rgba(78, 87, 187, 0.12) !important",
      overflow: "hidden !important",
    },
    "& .payroll-setup-success-modal .icon-box": {
      display: "flex",
      justifyContent: "center",
      marginBottom: "12px",
    },
    "& .payroll-setup-success-modal .title-box h1": {
      margin: "0 0 10px",
      textAlign: "center",
      color: "var(--color-text)",
      fontSize: "34px",
    },
    "& .payroll-setup-success-modal .message-box p": {
      margin: "0 0 24px",
      textAlign: "center",
      color: "var(--color-text-light)",
      lineHeight: 1.7,
      fontSize: "18px",
    },
    "& .payroll-setup-success-modal .call-to-action-button-box": {
      display: "flex",
      justifyContent: "center",
    },
    "& .payroll-setup-success-modal .call-to-action-button-box button": {
      backgroundColor: "var(--color-primary) !important",
      background: "var(--color-primary) !important",
      color: "var(--color-background) !important",
      width: "fit-content",
      minWidth: "140px",
      padding: "0.75rem 1rem",
      borderRadius: ".5rem",
      boxShadow: "0 14px 28px rgba(78, 87, 187, 0.2)",
      border: "none !important",
    },
    "& .payroll-setup-success-modal .call-to-action-button-box button span": {
      color: "#FFFFFF !important",
    },
  };
});

export const InputRow = styled(Row)(() => {
  return {
    gap: 0,
    alignItems: "center",
    border: "1px solid #d9dee7",
    borderRadius: ".5rem",
    backgroundColor: "#FFFFFF",
    "& input, & select": {
      width: "3.5rem",
      boxSizing: "border-box",
      outline: "none",
      border: "none",
      borderRight: "1px solid #d9dee7",
      padding: "calc(var(--cardPadding)/4)",
      fontWeight: "400",
    },
    "& span": {
      padding: "calc(var(--cardPadding)/4)",
    },
  };
});
